import React from "react";
import { AnimatePresence } from "framer-motion";
import Box from "../Box/Box";
import Fade from "../Animations/Fade";
import { FormBtn } from "../Styled/Text";
import { get } from "../../constants/theme";

const MAX_CHANNEL_URL =
  "https://max.ru/join/DBkPooFK1sBsog2y7-9XBnJU9kaeJaRDFSFMhu_hUb8";
const TELEGRAM_CHANNEL_URL =
  "https://t.me/ipfwatches";
const STORAGE_KEY = "max_popup_shown";

const SocialPopup = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) {
      return;
    }

    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 60000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = React.useCallback(() => {
    localStorage.setItem(STORAGE_KEY, "1");
    setIsVisible(false);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <Fade>
          {/* Оверлей */}
          <Box
            onClick={handleClose}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 200,
              backgroundColor: "rgba(28, 26, 25, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: ["20px", "20px", "0", "0"],
            }}
          >
            {/* Модальное окно */}
            <Box
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
              sx={{
                position: "relative",
                backgroundColor: get("palette.background.primary"),
                width: ["100%", "100%", "480px", "480px"],
                padding: [
                  "24px",
                  "24px",
                  "32px",
                  "32px",
                ],
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Кнопка закрытия */}
              <Box
                as="button"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "5px 10px",
                  color: get("palette.text.primary"),
                  fontSize: "22px",
                  lineHeight: 1,
                  fontFamily: "custom_42266",
                  opacity: 0.7,
                }}
              >
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 12.5L12.5 0.500122" stroke="currentColor" strokeLinecap="round"/>
                  <path d="M0.500092 0.5L12.5 12.5" stroke="currentColor" strokeLinecap="round"/>
                </svg>
              </Box>

              {/* Заголовок */}
              <Box
                as="h2"
                sx={{
                  fontFamily: "custom_42264",
                  fontWeight: 400,
                  fontSize: ["24px", "24px", "36px", "36px"],
                  lineHeight: [1.33, 1.33, 1, 1],
                  textTransform: "uppercase",
                  textAlign: "center",
                  color: get("palette.text.primary"),
                  margin: 0,
                  marginBottom: "12px",
                  letterSpacing: "0.29px",
                }}
              >
                СЛЕДУЙТЕ <Box as="br" sx={{ display: ["none", "none", "block"] }} /> ЗА НАМИ
              </Box>

              {/* Подзаголовок */}
              <Box
                as="p"
                sx={{
                  fontFamily: "custom_42266",
                  fontWeight: 400,
                  fontSize: "18px",
                  lineHeight: 1.33,
                  textAlign: "center",
                  color: get("palette.text.primary"),
                  margin: 0,
                  marginBottom: ["24px", "24px", "32px", "32px"],
                }}
              >
                Приглашаем в&nbsp;мир высокого часового искусства ИПФ&nbsp;в&nbsp;канале&nbsp;MAX или&nbsp;Telegram
              </Box>

              {/* Колонки каналов */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: ["column", "column", "row", "row"],
                  justifyContent: "center",
                  gap: ["12px", "12px", "32px", "32px"],
                  width: "100%",
                }}
              >
                {/* Колонка MAX */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: ["100%", "100%", "160px", "160px"],
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: ["none", "none", "block", "block"],
                      marginBottom: "16px",
                    }}
                  >
                    <Box
                      as="img"
                      src="/images/max-qr-code.png"
                      alt="QR-код канала MAX"
                      sx={{
                        display: "block",
                        width: "160px",
                        height: "160px"
                      }}
                    />
                  </Box>
                  <FormBtn
                    as="a"
                    href={MAX_CHANNEL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClose}
                    sx={{
                      marginTop: 0,
                      width: "100%",
                      textDecoration: "none",
                      letterSpacing: "-0.156px",
                      "@media screen and (min-width: 600px)": {
                        fontSize: "18px",
                        lineHeight: "18px",
                        border: "none",
                        padding: 0,
                        marginBottom: 0,
                        minHeight: "unset",
                      },
                      "@media screen and (max-width: 599px)": {
                        fontSize: "18px !important",
                        lineHeight: "18px",
                      },
                    }}
                  >
                    перейти в&nbsp;MAX
                  </FormBtn>
                </Box>

                {/* Колонка TG */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: ["100%", "100%", "160px", "160px"],
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: ["none", "none", "block", "block"],
                      marginBottom: "16px",
                    }}
                  >
                    <Box
                      as="img"
                      src="/images/telegram-qr-code.png"
                      alt="QR-код канала Telegram"
                      sx={{
                        display: "block",
                        width: "160px",
                        height: "160px"
                      }}
                    />
                  </Box>
                  <FormBtn
                    as="a"
                    href={TELEGRAM_CHANNEL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClose}
                    sx={{
                      marginTop: 0,
                      width: "100%",
                      textDecoration: "none",
                      letterSpacing: "-0.156px",
                      "@media screen and (min-width: 600px)": {
                        fontSize: "18px",
                        lineHeight: "18px",
                        border: "none",
                        padding: 0,
                        marginBottom: 0,
                        minHeight: "unset",
                      },
                      "@media screen and (max-width: 599px)": {
                        fontSize: "18px !important",
                        lineHeight: "18px",
                      },
                    }}
                  >
                    перейти в&nbsp;TG
                  </FormBtn>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      )}
    </AnimatePresence>
  );
};

export default React.memo(SocialPopup);
